<div id="file-preview-modal" #modal uk-modal>
  <div [ngClass]="{ 'white-background': fileType === 'txt' }" class="uk-modal-dialog">
    <button *ngIf="fileType === 'pdf' || fileType === 'txt'" class="uk-modal-close-default" type="button" uk-close></button>
    <div
      [ngClass]="{ 'dark-background': fileType === 'pdf', 'uk-modal-close': fileType !== 'pdf' && fileType !== 'txt' }"
      class="uk-modal-body uk-flex uk-flex-center uk-flex-middle">
      <embed *ngIf="link" [src]="link" type="application/pdf" width="100%" height="100%" />
      <img *ngIf="imgSrc" [src]="imgSrc" />
    </div>
  </div>
</div>
